import { ReactNode, SyntheticEvent } from 'react';
import {
  FormControlLabel as MUIFormControlLabel,
  Switch as MUISwitch,
  SwitchProps as MUISwitchProps,
  SxProps,
} from '@mui/material';

import fonts from '@atom/styles/fonts';

type AtomMUIProps = {
  label?: ReactNode;
  sx?: SxProps;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  color?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
  classes?: any;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (event: SyntheticEvent<any>, toggled: boolean) => void;
};

export type SwitchProps = AtomMUIProps;

export const Switch = (props: SwitchProps) => {
  const {
    label = '',
    labelPlacement = 'end',
    color = 'primary',
    sx,
    ...data
  } = props;

  const sxTypography: SxProps = {
    fontSize: fonts.md,
  };

  const MUIProps: MUISwitchProps = data;

  return (
    <MUIFormControlLabel
      control={<MUISwitch {...MUIProps} color={color} />}
      slotProps={{ typography: { sx: sxTypography } }}
      sx={sx}
      label={label}
      labelPlacement={labelPlacement}
    />
  );
};

export default Switch;
